import classNames from 'classnames';
import {ReactNode} from 'react';

type ActionButtonsProps = {
  children: ReactNode,
  className?: string
}

const ActionButtons = ({children, className=''}: ActionButtonsProps ) =>
  <div className={classNames('action-buttons', {[className]: true})}>
    {children}
  </div>;

export default ActionButtons;
